import { SearchSubRuleStateResponse } from '../../../integrated-client';
import { SearchSubRuleBulkUpdateData, SearchSubRuleBulkUpdateFormValidationData } from '../../../integrated-client/models';

export interface ISearchSubRuleBulkUpdateData extends SearchSubRuleBulkUpdateData {}

export interface ISearchSubRuleBulkEditorValidationData extends SearchSubRuleBulkUpdateFormValidationData {}

export interface ISearchSubRuleBulkEditorData {
  editorData?: ISearchSubRuleBulkUpdateData;
  validation?: ISearchSubRuleBulkEditorValidationData;
  searchSubRuleEditBulkResponse?: Array<SearchSubRuleStateResponse>;
}

export class SearchSubRuleBulkEditorData implements ISearchSubRuleBulkEditorData {
  editorData?: ISearchSubRuleBulkUpdateData;

  constructor() {
    this.editorData = {
      excludeUpSell: null,
      excludeBaglessFares: null,
      excludeDoubleConnections: null,
      directFlightsOnly: null,
      disabled: null,
      restrictMultiAirportConnections: null,
      maxPricePoints: { key: false, value: undefined },
      maxPriceSolutions: { key: false, value: undefined },
      maxConnectionTimeHours: { key: false, value: undefined },
      maxConnectionTimeMinutes: { key: false, value: undefined },
    };
  }
}
